import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AppSnackBarConfig } from '../Interfaces/snackbar.interface';

@Injectable({
  providedIn: 'root',
})
export class MsgService {
  private readonly _snackBar = inject(MatSnackBar);
  private readonly _translate = inject(TranslateService);

  showSnackBar(key: string, config: AppSnackBarConfig = {}): void {
    this._snackBar.open(
      this._translate.instant(key),
      this._translate.instant('backoffice.common.actions.close'),
      {
        duration: config.duration ?? 5000,
        panelClass: [`snack-bar-${config.type ?? 'success'}`],
        horizontalPosition: config.horizontalPosition ?? 'center',
        verticalPosition: config.verticalPosition ?? 'bottom',
      },
    );
  }
}
